import { useMarkNotificationAsRead } from '@/common/hooks/useMarkNotificationAsRead'
import { useEffect, useRef } from 'react'

interface UseNotificationVisibilityDebounceProps {
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useNotificationVisibilityDebounce = ({
  onSuccess,
  onError,
}: UseNotificationVisibilityDebounceProps = {}) => {
  const visibleNotificationsRef = useRef<Set<string>>(new Set())
  const processingRef = useRef<Set<string>>(new Set())
  const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null)

  const { mutate: markAsRead } = useMarkNotificationAsRead({
    onSuccess,
    onError,
  })

  const addVisibleNotification = (id: string) => {
    if (processingRef?.current?.has(id)) return

    visibleNotificationsRef.current.add(id)

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current)
    }

    debounceTimeoutRef.current = setTimeout(() => {
      const idsToMarkAsRead = Array.from(visibleNotificationsRef.current)
      
      if (idsToMarkAsRead.length > 0) {
        idsToMarkAsRead.forEach((id) => processingRef.current.add(id))
        
        markAsRead({
          recipient_messages: idsToMarkAsRead.map((id) => ({ id })),
        })

        visibleNotificationsRef.current.clear()
      }
    }, 1000)
  }

  useEffect(() => {
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current)
      }
    }
  }, [])

  return {
    addVisibleNotification,
  }
}
